// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 918 ? "4596ecfc" : chunkId) + "." + {"85":"1ca90bf2bcee9243","221":"3e653a32498095e3","437":"243f5633c2f1e379","618":"f218b4b460402324","719":"44c337fa23ca7936","763":"17278e604227469b","866":"f264e0299c4f37f2","918":"8a2fc32504a064e5"}[chunkId] + ".js";
};